import { useContext, RefObject } from "react";
import BryntumContext from "../context/bryntumContext";
import { ISwivuProject } from "@/types/SwivuProject";
import { IAuthUser } from "@/types/AuthUser";
import ViewManager from "@/other/feature/views/ViewManager";
import { Board } from "@/bryntum-lib/models/Board";
import { ISwivuStore } from "@/types/SwivuStore";
import useEditorHandler from "./useEditorHandler";
import { VIEW_TYPES } from "@/other/constants/OtherKeys";
import { useEntityManager } from "./useEntityManager";
import type SwivuWebSocketService from "@/other/services/SwivuWebSocketService";

interface ISwivuBryntumContext {
  project: ISwivuProject;
  user: IAuthUser | null;
  viewManager: ViewManager & {
    renderState: {
      selectedView: {
        viewType: typeof VIEW_TYPES;
      } | null;
    };
  } | null;
  boardManager?: { boardNameStore: ISwivuStore<Board> } | undefined;
  editorHandler: ReturnType<typeof useEditorHandler>;
  entityManager: ReturnType<typeof useEntityManager>;
  swivuWebSocketRef?: RefObject<SwivuWebSocketService | null>;
  boardSessionIdRef?: RefObject<string>;
  userPreferences: null | {
    updateSetting: (key: string, value: string, isBoardPref?: boolean) => void;
    getSetting: (key: string, defaultValue?: string, isBoardPref?: boolean) => string | undefined;
  }
  swivuAppGrants: {
    label: string;
    value: number;
  }[];
  selectedBoard: {
    id: number;
    name: string;
    record: Board;
  } | null;
  [key: string]: unknown;
}

export const useSwivuBryntumContext = () => {
  const context = useContext(BryntumContext) as unknown as ISwivuBryntumContext;

  return context;
};
